class Storage {
  hasData(key) {
    return !!localStorage[key] && !!localStorage[key].length
  }

  _getKey(key) {
    return (`HNB_${key}`).toUpperCase()
  }

  get(key, _default = null) {
    key = this._getKey(key)
    if (!this.hasData(key)) {
      return _default
    }
    return JSON.parse(localStorage[key])
  }

  set(key, value) {
    localStorage.setItem(this._getKey(key), JSON.stringify(value))
  }

  remove(key) {
    localStorage.removeItem(this._getKey(key))
  }

  clear() {
    localStorage.clear()
  }
}

export default new Storage()
